<template>
  <section class="space-y-6">
    <div class="rounded-3xl border border-gray-100 bg-white p-6 shadow-sm">
      <div class="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 class="text-lg font-semibold text-ink">Venue list</h2>
          <p class="text-sm text-muted">Manage vendor venues and pricing.</p>
        </div>
      <RouterLink to="/dashboard/add-venue" class="rounded-full bg-brand px-4 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-brandDark">
        New venue
      </RouterLink>
      </div>

      <div class="mt-6 overflow-hidden rounded-2xl border border-gray-100">
        <div class="grid grid-cols-6 gap-4 bg-gray-50 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-muted">
          <span>Venue</span>
          <span>Type</span>
          <span>Per day</span>
          <span>Rooms</span>
          <span>Vendor ID</span>
          <span></span>
        </div>
        <div class="divide-y divide-gray-100 text-sm">
          <div class="grid grid-cols-6 items-center gap-4 px-4 py-4">
            <div>
              <p class="font-semibold text-ink">Lumen Hall</p>
              <p class="text-xs text-muted">Downtown · 12.9716, 77.5946</p>
            </div>
            <span class="text-muted">Banquet</span>
            <span class="text-muted">$2,400</span>
            <span class="text-muted">6</span>
            <span class="text-muted">VND-2401</span>
            <div class="flex items-center justify-end gap-2">
              <RouterLink to="/dashboard/edit-venue/1" class="rounded-full border border-gray-200 px-3 py-1.5 text-xs font-semibold text-ink transition hover:border-brand hover:text-brand">
                Edit
              </RouterLink>
              <button class="rounded-full border border-red-200 px-3 py-1.5 text-xs font-semibold text-red-600 transition hover:border-red-300">
                Delete
              </button>
            </div>
          </div>
          <div class="grid grid-cols-6 items-center gap-4 px-4 py-4">
            <div>
              <p class="font-semibold text-ink">Harbor Studio</p>
              <p class="text-xs text-muted">Waterfront · 12.9345, 77.6111</p>
            </div>
            <span class="text-muted">Studio</span>
            <span class="text-muted">$1,850</span>
            <span class="text-muted">4</span>
            <span class="text-muted">VND-2401</span>
            <div class="flex items-center justify-end gap-2">
              <RouterLink to="/dashboard/edit-venue/2" class="rounded-full border border-gray-200 px-3 py-1.5 text-xs font-semibold text-ink transition hover:border-brand hover:text-brand">
                Edit
              </RouterLink>
              <button class="rounded-full border border-red-200 px-3 py-1.5 text-xs font-semibold text-red-600 transition hover:border-red-300">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script setup>
import { RouterLink } from 'vue-router'
</script>
